import artificialIntelligence from "./artificialIntelligence";
import dashboard from "./dashboard";
import settings from "./settings";

const menuItems = {
  items: [dashboard, artificialIntelligence, settings],
};

export default menuItems;
